export default {
  state: {
    safeArea: {
      top: 47,
      bottom: 84,
    },
  },
};
